module.exports = __webpack_public_path__ + "img/menu-icon-4-1.3d4377c2.svg";